// usePostHeight.js
import { useEffect } from "react";

export function usePostHeight() {
  useEffect(() => {
    const DRUPAL_ORIGIN =
      process.env.REACT_APP_DRUPAL_ORIGIN || "https://ccbwqportal.org";

    let raf = 0;
    const send = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const h = Math.max(
          document.documentElement.scrollHeight,
          document.body.scrollHeight
        );
        // console.log("Posting height:", h);
        window.parent?.postMessage(
          { type: "EMBED_SIZE", height: h },
          DRUPAL_ORIGIN
        );
      });
    };

    send();
    setTimeout(send, 100);

    const ro = new ResizeObserver(send);
    ro.observe(document.body);

    const mo = new MutationObserver(send);
    mo.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    window.addEventListener("load", send);
    window.addEventListener("resize", send);

    return () => {
      cancelAnimationFrame(raf);
      ro.disconnect();
      mo.disconnect();
      window.removeEventListener("load", send);
      window.removeEventListener("resize", send);
    };
  }, []);
}
